import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { MatTableDataSource } from '@angular/material/table';
import { EventResource } from 'src/app/interfaces/event-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { BulkService } from 'src/app/services/bulk.service';
import { EventService } from 'src/app/services/event.service';

@Component({
  selector: 'app-bulk',
  templateUrl: './bulk.component.html',
  styleUrls: ['./bulk.component.scss']
})
export class BulkComponent implements OnInit {
  filteredOptions: Array<EventResource> = [];
  bulkForm: UntypedFormGroup;
  dataSource: MatTableDataSource<any>;
  dataSource_success: MatTableDataSource<any>;
  displayedColumns = ['number', 'customer', 'event', 'input'];
  hasImportedData:boolean = false;
  constructor(
    private fb: UntypedFormBuilder,
    private bulkService: BulkService,
    private eventService: EventService
  ) {
    this.bulkForm = this.fb.group({
      type: ['INPUT_TYPE_VOUCHER', [Validators.required]],
      date: [this.formatDate(new Date()), [Validators.required]],
      data: ['', [Validators.required]],
      eventPublicID: ['']
    })
  }

  ngOnInit() {
    this.eventService.searchForEvents(0, 1, ['ACTIVE'], null, null, null).subscribe((val: PagedResources<EventResource>) => {
      this.eventService.searchForEvents(0, val.page.totalElements, ['ACTIVE'], null, null, null).subscribe((val: PagedResources<EventResource>) => {
        this.filteredOptions = val.content;
      })
    })
  }

  importData() {
    this.hasImportedData =false;
    this.bulkForm.markAllAsTouched();
    this.bulkForm.markAsDirty();

    console.log(this.bulkForm)

    if (this.bulkForm.invalid) {
      return;
    }
    this.bulkService.uploadBulkAttendanceList(this.bulkForm.getRawValue().date, this.bulkForm.getRawValue().type, this.bulkForm.getRawValue().data, this.bulkForm.getRawValue().eventPublicID).subscribe({
      next: res => {
        this.hasImportedData =true;
        
        this.dataSource_success = new MatTableDataSource(res['reservations'])
        this.dataSource = new MatTableDataSource(res['failedAttendances'])
        console.log(res)
      },
      error: err => {
        console.log(err)
      }
    })
  }

  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  changeValidation(event: MatRadioChange) {
    console.log(event)
    if (event.value == "INPUT_TYPE_CARD") {
      this.bulkForm.controls['eventPublicID'].addValidators(Validators.required);
      this.bulkForm.controls['eventPublicID'].updateValueAndValidity();
    } else if (event.value == " INPUT_TYPE_VOUCHER") {
      this.bulkForm.controls['eventPublicID'].clearValidators();
      this.bulkForm.controls['eventPublicID'].updateValueAndValidity();
      this.bulkForm.controls['eventPublicID'].reset()
    }
  }
}
